// @ts-nocheck
import { initialState } from './reducer';

const obsSelector = (state) => state.orderByKit || initialState;

export const getObsKitColumns = (state) => {
	const { kit, store, warehouse, order } = obsSelector(state).columns;
	return { kitColumns: kit, storeColumns: store, warehouseColumns: warehouse, orderColumns: order || [] };
};

export const getObsKitOrderData = (state) => obsSelector(state).orderData;

export const getObsKitAvailability = (state) => obsSelector(state).availability;

export const getObsKitLoading = (state) => obsSelector(state).loading;
